// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d7b07830","703":"b572b37b"}[chunkId] + ".chunk.js";
};